import React from 'react'
import { Link } from 'react-router-dom'

export default function ForbiddenPage() {
  return (
    <div className="py-20 sm:py-32 px-4 sm:px-6 text-center max-w-2xl mx-auto space-y-6">
      <div className="w-20 h-20 rounded-2xl bg-[#F3EFEA] text-[#C25E27] flex items-center justify-center text-4xl mx-auto border border-[#E6DFD5]">
        <i className="fa-solid fa-lock" aria-hidden="true" />
      </div>

      <span className="text-xs font-bold uppercase tracking-widest text-[#C25E27]">
        Fejl 403
      </span>

      <h1 className="text-3xl sm:text-4xl font-extrabold text-[#241F1C]">
        Adgang nægtet (Forbidden)
      </h1>

      <p className="text-sm sm:text-base text-[#6E635C] leading-relaxed">
        Du har ikke rettigheder til at tilgå denne ressource.
      </p>

      <div className="pt-4 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-[#C25E27] hover:bg-[#A84E1C] text-white px-6 py-3 rounded-xl font-bold text-sm shadow-sm transition-colors"
        >
          <i className="fa-solid fa-house text-xs" aria-hidden="true" />
          <span>Gå til forsiden</span>
        </Link>
        <Link
          to="/kontakt"
          className="inline-flex items-center gap-2 bg-white text-[#241F1C] border border-[#E6DFD5] hover:bg-[#FAF8F5] px-6 py-3 rounded-xl font-bold text-sm transition-colors"
        >
          <span>Kontakt os</span>
        </Link>
      </div>
    </div>
  )
}
